// 37_VOICE_TO_TEXT (doc 37/01 §3.5) -- the voice-to-text wiring shared by the
// two hosts of the AI Tutor composer (the chat route and the Board
// Workspace's chat panel). One controller per host (voiceInput.js); the host
// renders `<composer :voice="composerVoice" @voice-start="onVoiceStart" ...>`
// and keeps everything else it already does.
//
// Availability is Subway's (`capabilities.voiceInput` of the Reports summary,
// like the whiteboard): unknown or unreadable = the inert microphone, as
// before. The transcript only ever reaches the composer's draft
// (`appendDraft`); sending stays the Student's own Send.

import { createVoiceInput } from '@/services/aiTutor/voiceInput'
import { collaborators as aiTutorCollaborators } from '@/store/modules/aiTutor'

export function voiceCapabilityFrom(summary) {
  const capabilities = summary && summary.capabilities
  return !!capabilities && capabilities.voiceInput === 'available'
}

export default {
  data() {
    return {
      voiceAvailable: false,
    }
  },
  computed: {
    composerVoice() {
      return this.voiceAvailable && this.voiceInput
        ? this.voiceInput.state
        : null
    },
    voiceBusy() {
      const voice = this.composerVoice
      return (
        !!voice &&
        (voice.phase === 'recording' || voice.phase === 'transcribing')
      )
    },
  },
  created() {
    // Not reactive itself: only its `state` is (Vue.observable).
    this.voiceInput = createVoiceInput({
      // Read at call time, so the store's collaborator seam stays the one
      // place the transport comes from.
      api: {
        createVoiceUploadUrl: dto =>
          aiTutorCollaborators.api.createVoiceUploadUrl(dto),
        uploadToPresignedPost: (upload, blob, options) =>
          aiTutorCollaborators.api.uploadToPresignedPost(upload, blob, options),
        createVoiceTranscription: dto =>
          aiTutorCollaborators.api.createVoiceTranscription(dto),
      },
      uiLocale: () => (this.$i18n && this.$i18n.locale === 'fa' ? 'fa' : 'en'),
      onTranscript: text => {
        const composer = this.$refs.composer
        if (composer && typeof composer.appendDraft === 'function') {
          composer.appendDraft(text)
        }
      },
    })
  },
  beforeDestroy() {
    if (this.voiceInput) this.voiceInput.destroy()
  },
  methods: {
    onVoiceStart() {
      if (this.voiceAvailable && this.voiceInput) this.voiceInput.start()
    },
    onVoiceStop() {
      if (this.voiceInput) this.voiceInput.stop()
    },
    onVoiceCancel() {
      if (this.voiceInput) this.voiceInput.cancel()
    },
    onVoiceDismiss() {
      if (this.voiceInput) this.voiceInput.dismiss()
    },
    // Another conversation, or leaving: nothing under way may land in the
    // next draft, and the microphone is released.
    resetVoice() {
      if (this.voiceInput) this.voiceInput.reset()
    },
  },
}
